/**
 * ServicePropertySortSettings содержит параметры сортировки по свойству
 * дополнительных услуг
 */
export class ServicePropertySortSettings {
  /**
   * Флаг включает возможность сортировки по полю
   */
  public IsSortEnable: boolean = false

  /**
   * Параметр задает доступные варианты сортировки по полю
   */
  public AvailableDirection: "asc" | "desc" | "both" = "both"

  /**
   * Локализованные названия сортировок по возрастанию и убыванию.
   * Выводятся в зависимости от выбранного типа сортировки.
   */
  public AscDirectionCaption: string = ""
  public DescDirectionCaption: string = ""

  /**
   * Порядковый номер сортировки. Чем ниже, тем он ближе к левому краю.
   */
  public DirectionPosition: number = 0

  /**
   * Заглушка для запрета прямого создания объектов данного типа
   * @private
   */
  private constructor() {
  }

  /**
   * RestoreSettings выполняет восстановление данных объекта настроек
   * Функция выполняет нормализацию значений настроек.
   * Функция дополняет недостающие настройки значениями по умолчанию.
   *
   * @param data
   */
  public static RestoreSettings(data: any): ServicePropertySortSettings {
    let result = new ServicePropertySortSettings();

    if (typeof data === "string") {
      data = JSON.parse(data)
    }

    if (typeof data !== "object") {
      return result;
    }

    Object.keys(result).map((key: keyof ServicePropertySortSettings) => {
      // @ts-ignore
      result[key] = ServicePropertySortSettings.GetCorrectFieldValue(key, data[key])
    })

    return result;
  }

  /**
   * GetCorrectFieldValue выполняет восстановление данных поля из переданного значения настроек.
   * Данный метод так же проводит валидацию значения каждой из настроек поля. Метод возвращает
   * значение по умолчанию, если значение передано не корректно.
   */
  public static GetCorrectFieldValue<T extends keyof ServicePropertySortSettings>(field: T, data: any): any {
    let defaults = new ServicePropertySortSettings()

    if (data === undefined) {
      return defaults[field]
    }

    switch (field) {
      case "DirectionPosition":
        return typeof data === "number" && data >= 0 ? data : defaults[field]
      case "IsSortEnable":
        return !!data
      case "AscDirectionCaption":
      case "DescDirectionCaption":
        return typeof data === "string" ? data : defaults[field]
      case "AvailableDirection":
        return typeof data === "string" && ["asc", "desc", "both"].includes(data) ? data : defaults[field]
    }

    return defaults[field];
  }
}